import { FormControl, FormGroup } from '@angular/forms';
import { PackagePaymentMethod, Bank } from '@beautyapp/core';

export function createPaymentGroup() {
  return new FormGroup({
    paymentMethod: new FormControl<PackagePaymentMethod>('CASH', {
      nonNullable: true,
    }),
    cash: new FormControl<number | null>(null),
    card: new FormControl<number | null>(null),
    balance: new FormControl<number | null>(null),
    bank: new FormControl<Bank | null>(null),
    bankTransfer: new FormControl<number | null>(null),
    bankTransferBank: new FormControl<Bank | null>(null),
    consignation: new FormControl<number | null>(null),
  });
}

export type PaymentGroup = ReturnType<typeof createPaymentGroup>;

/**
 * Channel payload for the update-purchase CHARGE. Always emits the five numeric
 * channels as numbers (0 when empty) so the backend resolvePaymentChannels MIXED
 * guard (which requires cash AND card to be present) never rejects; bank ids only
 * when set.
 */
export function buildChargePayload(g: PaymentGroup): Record<string, unknown> {
  const v = g.getRawValue();
  const out: Record<string, unknown> = {
    paymentMethod: v.paymentMethod,
    cash: Number(v.cash) || 0,
    card: Number(v.card) || 0,
    balance: Number(v.balance) || 0,
    bankTransfer: Number(v.bankTransfer) || 0,
    consignation: Number(v.consignation) || 0,
  };
  if (v.bank) out['bank'] = v.bank;
  if (v.bankTransferBank) out['bankTransferBank'] = v.bankTransferBank;
  return out;
}
